import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'


const _hoisted_1 = { class: "header-v2" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = { class: "body content" }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "panelButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "rightPanel",
            style: _normalizeStyle({ height: _ctx.IsEmbedded ? 'calc(100vh - 40px)' : 'calc(100vh - 47px)' })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _cache[2] || (_cache[2] = _createTextVNode(" default header ", -1))
                ], true)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  width: "24",
                  src: _imports_0,
                  class: "theme-svg",
                  id: "close-v2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _cache[3] || (_cache[3] = _createTextVNode(" default body ", -1))
              ], true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CommonButton, {
                    type: _ctx.ButtonType.Primary,
                    text: _ctx.Localizer.Localize('Ok_PascalCase'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                  }, null, 8, ["type", "text"])
                ])
              ], true)
            ]),
            _renderSlot(_ctx.$slots, "modal", {}, undefined, true)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}